import React from "react";
import {LoadingModal} from "../../../model/http_loading";
import {SuccessWidget} from "../../personal/arbitration/success_widget";
import {useWait} from "../../../utils/wait_fn";
import {ModalProps} from "../../../provider/model_provider";
import styled from "styled-components";
import {AppConfig} from "../../../config";
import {HttpServer} from "../../../net/http_server";
import {useSignFn} from "../../../utils/sign_fn";
import {addArbiterJson} from "../../personal/fn/get_sign";
import {ButtonWidget} from "../../../widget/pub/button_widget";
import {useParams} from "react-router-dom";

interface TisArbitrationInterface extends ModalProps {
    claim_id: number,
    claim_hash: string,
    type: string,
    updateFn?: Function,
    isAdmin: boolean
}

export const TisArbitrationModel: React.FC<TisArbitrationInterface> = ({
                                                                           onDismiss,
                                                                           claim_hash,
                                                                           claim_id,
                                                                           type,
                                                                           updateFn,
                                                                           isAdmin,
                                                                       }) => {
    const sign = useSignFn();

    const {data, status, request} = useWait<any>(async () => {
        let _params = assessmentJson({
            claim_hash,
            type,
            claim_id,
            isAdmin
        });
        let _hex = await sign(_params);
        if (isAdmin)
            await HttpServer.assessmentAdmin(_hex, _params)
        else
            await HttpServer.assessmentP(_hex, _params)
        updateFn && updateFn()
    });

    return (
        <LoadingModal status={status} data={data} onDismiss={onDismiss} success={SuccessWidget}>
            <WapStyle>
                <h3>Would you like to confirm your approval for this claim?</h3>
                <h4>{type}</h4>
                <div className={'buttons'}>
                    <ButtonWidget
                        onClick={onDismiss}
                        bgColor={'#0064FD'}
                        text={'Cancel'}
                        size={{x: 7, y: 30}}
                    />
                    <ButtonWidget
                        onClick={request}
                        bgColor={'#0064FD'}
                        text={'Confirm'}
                        size={{x: 7, y: 30}}
                    />
                </div>
            </WapStyle>
        </LoadingModal>
    );
}

const assessmentJson = (model: TisArbitrationInterface): string => {

    let _name = 'claim_assessment';
    return JSON.stringify({
        domain: {
            name: _name,
            chainId: AppConfig.chainId.toString(),
        },
        message: {
            method: _name,
            content: {
                user_id: HttpServer.account,
                claim_id: model.claim_id,
                cover_hash: model.claim_hash,
                status: model.type,
            }
        },
        primaryType: 'Place',
        types: {
            EIP712Domain: [
                {name: 'name', type: 'string'},
                {name: 'chainId', type: 'uint256'},
            ],
            Place: [
                {name: 'content', type: 'Model'},
                {name: 'method', type: 'string'},
            ],
            Model: [
                {name: 'user_id', type: 'string'},
                {name: 'claim_id', type: 'uint256'},
                {name: 'cover_hash', type: 'string'},
                {name: 'status', type: 'string'},
            ],

        }
    });
}

const WapStyle = styled.div`
  width: 368px;
  padding: 30px 0;
  background: linear-gradient(270deg, #E3EFFF 0%, #FAF0FF 100%);
  box-shadow: 0px 0px 16px 1px rgba(126, 126, 126, 0.45);
  border-radius: 12px;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  h3 {
    height: 20px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    padding: 0 20px;
  }

  h4 {
    height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #222222;
    line-height: 40px;
    margin: 30px 0;
  }

  .buttons {
    width: 70%;
    display: flex;
    justify-content: space-around;
  }
`
